// Item (b), batch 3: the automatic follow-up emails going out in the next few working days.

/** What a call, meeting or note logged since the last email will do at send time (item d), or ''. */
export function contactNote(row) {
  if (!row || !row.contactLoggedOn) return ''
  var what = row.onLoggedContact === 'STOP' ? 'the emails will stop'
    : 'it will be paused' + (row.pausedUntil ? ' until ' + row.pausedUntil : '')
  return 'Contact logged ' + row.contactLoggedOn + ': ' + what
}

/** The rows a filter by salesperson leaves (null = everyone). */
export function bySalesperson(rows, salespersonId) {
  if (salespersonId === null || salespersonId === undefined) return rows || []
  return (rows || []).filter(r => r.salespersonId === salespersonId)
}

/** The salespeople in the list, for the filter, by name. */
export function salespeople(rows) {
  var seen = {}
  ;(rows || []).forEach(r => { if (r.salespersonId !== null && r.salespersonId !== undefined) seen[r.salespersonId] = r.salespersonName || ('User ' + r.salespersonId) })
  return Object.keys(seen).map(id => ({ id: Number(id), name: seen[id] })).sort((a, b) => a.name.localeCompare(b.name))
}

/** The page's explanation line. */
export function headline(data) {
  if (!data) return ''
  if (!data.enabled) return 'Follow-up emails are switched off, so none are going out.'
  return 'Automatic follow-up emails due in the next ' + data.workingDays + ' working days (to ' + data.until + '). ' +
    'Untick an email to skip it; the quote\'s later emails still go.'
}
